const Lock: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M8.49935 0.666504C6.28348 0.666504 4.49935 2.45063 4.49935 4.6665V5.33317C3.76602 5.33317 3.16602 5.93317 3.16602 6.6665V13.3332C3.16602 14.0665 3.76602 14.6665 4.49935 14.6665H12.4993C13.2327 14.6665 13.8327 14.0665 13.8327 13.3332V6.6665C13.8327 5.93317 13.2327 5.33317 12.4993 5.33317V4.6665C12.4993 2.45063 10.7152 0.666504 8.49935 0.666504ZM8.49935 1.99984C10.0168 1.99984 11.166 3.14904 11.166 4.6665V5.33317H5.83268V4.6665C5.83268 3.14904 6.98189 1.99984 8.49935 1.99984ZM8.49935 8.6665C9.23268 8.6665 9.83268 9.2665 9.83268 9.99984C9.83268 10.7332 9.23268 11.3332 8.49935 11.3332C7.76602 11.3332 7.16602 10.7332 7.16602 9.99984C7.16602 9.2665 7.76602 8.6665 8.49935 8.6665Z"
      />
    </svg>
  );
};

export default Lock;
